<script setup lang="ts">
import { provide } from "vue";

export interface TagGroupProps {
  /** The color of the tags in the tag group. Defines their visual meaning. */
  color?: "information" | "success" | "failure" | "cancel" | "new" | "deal" | "light" | "dark";
  outlined?: boolean;
  size?: "small" | "medium";
}

const { color = "information", outlined = false, size = "medium" } = defineProps<TagGroupProps>();

provide("tagGroupContext", { color, outlined, size });
</script>

<template>
  <div>
    <div class="flex flex-wrap items-start gap-2" role="group" data-testid="clr-tag-group">
      <slot />
    </div>
  </div>
</template>
